import { DescriptionsItemProps } from 'antd/lib/descriptions/Item';
import { Caption } from 'app/components/Typography/Caption';
import { get } from 'lodash';

export const POITEM_OVERALL_DESCRIPTION_DEFS: Array<
  Partial<DescriptionsItemProps> & {
    render?<T = any>(item: T, record?: any): React.ReactNode;
    dataIndex: string;
  }
> = [
  {
    label: 'Total Order Qty.',
    dataIndex: 'inspectionSubPOItems',
    render: (item: any) => {
      if (Array.isArray(item) && item.length > 0) {
        return item
          .map(({ orderQty }) => (isNaN(orderQty) ? 0 : parseFloat(orderQty)))
          .reduce((acc, cur) => acc + cur, 0);
      }
      return 'N/A';
    }
  },
  {
    label: 'Total # of Cartons',
    dataIndex: 'inspectionSubPOItems',
    render: (item: any) => {
      if (Array.isArray(item) && item.length > 0) {
        return item
          .map(({ cartonsNo }) =>
            isNaN(cartonsNo) ? 0 : parseFloat(cartonsNo)
          )
          .reduce((acc, cur) => acc + cur, 0);
      }
      return 'N/A';
    }
  },
  {
    label: 'Signed Sample Available',
    dataIndex: 'isSignSample',
    render: (item: any) => {
      if (typeof item === 'undefined') return 'No';
      return item ? 'Yes' : 'No';
    }
  },
  {
    label: 'Sample Size',
    dataIndex: 'aql',
    render: (item: any) => {
      if (item) {
        return (
          <span style={{ display: 'inline-flex', gap: '8px' }}>
            <span>Critical {get(item, 'critical.sampleSize', 0)}</span>
            <span>Major {get(item, 'major.sampleSize', 0)}</span>
            <span>Minor {get(item, 'minor.sampleSize', 0)}</span>
          </span>
        );
      }
      return 'N/A';
    }
  },
  {
    label: 'AQL',
    dataIndex: 'criticalLevel',
    render: (item: any, record) => {
      if (record) {
        return (
          <span style={{ display: 'inline-flex', gap: '8px' }}>
            <span>
              Critical{' '}
              {record.isCustomSampling ? (
                <Caption style={{ fontSize: 'inherit' }}>/</Caption>
              ) : (
                get(record, 'criticalLevel', 0)
              )}
            </span>
            <span>
              Major{' '}
              {record.isCustomSampling ? (
                <Caption style={{ fontSize: 'inherit' }}>/</Caption>
              ) : (
                get(record, 'criticalMajorLevel', 0)
              )}
            </span>
            <span>
              Minor{' '}
              {record.isCustomSampling ? (
                <Caption style={{ fontSize: 'inherit' }}>/</Caption>
              ) : (
                get(record, 'criticalMinorLevel', 0)
              )}
            </span>
          </span>
        );
      }
      return 'N/A';
    }
  },
  {
    label: 'Defectives Accepted',
    dataIndex: 'aql',
    render: (item: any) => {
      if (item) {
        return (
          <span style={{ display: 'inline-flex', gap: '8px' }}>
            <span>Critical {get(item, 'critical.acceptanceLevel', 0)}</span>
            <span>Major {get(item, 'major.acceptanceLevel', 0)}</span>
            <span>Minor {get(item, 'minor.acceptanceLevel', 0)}</span>
          </span>
        );
      }
      return 'N/A';
    }
  }
];
